import axios from "axios";

// Variable
const weatherDataLink = process.env.REACT_APP_WEATHER_API_LINK;

const api = axios.create({
  baseURL: `${weatherDataLink}`,
  timeout: 10000,
});

function getTempInformation() {
  return api.get(`/gettempstatus`);
}

function getHumInformation() {
  return api.get(`/gethumstatus`);
}

function getWindInformation() {
  return api.get(`/getwindstatus`);
}

function getGustInformation() {
  return api.get(`/getguststatus`);
}

function getTideInformation() {
  return api.get(`/gettidestatus`);
}

function getOceanWeatherInformation() {
  return api.get(`/getoceanweather`);
}

export {
  getTempInformation,
  getHumInformation,
  getWindInformation,
  getGustInformation,
  getTideInformation,
  getOceanWeatherInformation,
};
